import React, { useState } from 'react'
import RdnaAutocomplete from '@ringdna/common/src/components/RdnaFormElements/RdnaAutoComplete'
import { Location, SFUser } from '../../../../../store/api/users-api'

type Props = {
  user: any
  disabled: boolean
  userList: SFUser[]
  setUserList: (list: SFUser[]) => void
  locations: Location[]
}

export default function LocationCell({ user, disabled, userList, setUserList, locations }: Props) {
  const [value, setValue] = useState<Location>(user.location)
  return (
    <RdnaAutocomplete
      id={`user-location`}
      className={'sn-cell-select'}
      onChange={(event, value) => {
        setValue(value)
        setUserList(userList.map(u => (u.salesforceId === user.salesforceId ? { ...u, location: value } : u)))
      }}
      options={locations}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={option => option.name}
      placeholder={'Location'}
      value={value}
      disabled={disabled}
    />
  )
}
